module.exports = __webpack_public_path__ + "asset/loading_2fjIPAFV.jpg";